import { ProductReviewsHeader } from 'components/Blocks/Reviews/ProductReviewsHeader';
import { ProductReviewsList } from 'components/Blocks/Reviews/ProductReviewsList';
import { useEffect, useRef, useState } from 'react';
import { ReviewsSummary } from 'types/review';

type ProductReviewsProps = {
    summary: ReviewsSummary;
    productUuid: string;
    increaseParentHeightCounter?: () => void;
};

export const ProductReviews = ({ summary, productUuid, increaseParentHeightCounter }: ProductReviewsProps) => {
    const paginationScrollTargetRef = useRef<null | HTMLDivElement>(null);
    const [shouldDisplayList, setShouldDisplayList] = useState(false);

    useEffect(() => {
        const observer = new IntersectionObserver(
            (entries) => {
                if (entries[0].isIntersecting) {
                    setShouldDisplayList(true);
                    observer.disconnect();
                }
            },
            { threshold: 0.1 },
        );

        const currentRef = paginationScrollTargetRef.current;
        if (currentRef) {
            observer.observe(currentRef);
        }

        return () => {
            if (currentRef) {
                observer.unobserve(currentRef);
            }
        };
    }, []);

    return (
        <div className="flex flex-col space-y-8 vl:space-y-16" ref={paginationScrollTargetRef}>
            <ProductReviewsHeader summary={summary} />
            <ProductReviewsList
                shouldDisplay={shouldDisplayList}
                increaseParentHeightCounter={increaseParentHeightCounter}
                productUuid={productUuid}
                paginationScrollTargetRef={paginationScrollTargetRef}
            />
        </div>
    );
};
